const RELOAD_AT_FLAG = "chunk-retry-reloaded-at";
// 방금 새로고침했는데 청크가 '또' 실패하면 해시 스큐가 아닌 다른 원인(진짜 깨진 청크)
// 일 가능성이 높으므로, 무한 새로고침 루프를 막기 위해 그대로 던진다. 이 창(cooldown)
// 안의 재실패만 그렇게 보고, 이보다 오래 지난 뒤의 실패는 '그 사이 새 배포가 나 청크가
// 교체된' 정상 상황으로 보고 다시 1회 새로고침한다.
const RETRY_COOLDOWN_MS = 10_000;

/** 배포로 청크 해시가 바뀌면 이미 열려 있던 탭의 lazy import 가 무기한 404 로
 * 실패한다. 실패 시 1회 새로고침으로 최신 자산을 받아 복구한다 — 단, 재시도 예산은
 * "탭 세션당 1회"가 아니라 "배포(=새로고침 시점)당 1회"다. 예전에는 한 번 쓰면 지워지지
 * 않는 sessionStorage 플래그를 써서, 탭을 오래 켜둔 채 '두 번째' 배포를 만나면 재시도
 * 없이 즉시 던져 흰 화면이 됐다. 이제는 마지막 새로고침 시각을 저장해, 쿨다운을 벗어난
 * (=사실상 다음 배포에서의) 실패는 다시 복구한다. Capacitor/Electron 은 dist 를 동봉해
 * file:// 로 로드하므로 배포 중 해시가 바뀔 일이 없어 사실상 웹에서만 발동한다. */
export function withChunkRetry<T>(importer: () => Promise<T>): () => Promise<T> {
  return async () => {
    try {
      return await importer();
    } catch (err) {
      // 마지막 새로고침 직후(쿨다운 이내)의 재실패면 루프 방지를 위해 던진다.
      const lastReloadAt = Number(sessionStorage.getItem(RELOAD_AT_FLAG) ?? 0);
      if (Date.now() - lastReloadAt < RETRY_COOLDOWN_MS) throw err;
      sessionStorage.setItem(RELOAD_AT_FLAG, String(Date.now()));
      window.location.reload();
      // 새로고침으로 페이지 자체가 다시 로드되므로 이 Promise 는 그냥 미해결로 둔다.
      return new Promise<T>(() => {});
    }
  };
}
